import {
   BIKE_LICENSE_TYPE_OPTIONS, BIKE_NO_CLAIM_BONUS_YEAR_OPTIONS,
   BIKE_RIDER_OPTIONS,
   BIKE_USAGE_OPTIONS,
   DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST, OTHER_OWNED_VEHICLE_NUMBER_OPTIONS, YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import {isNotStringOrEmptyString} from "@utils/string";
import {isDateLessThanNow, isInLabelValueArrayAsString, isValidDateTimeString} from "@utils/validators";
import {validateCommonPolicyHolderClaims} from "@validators/common/sub-components/validate-common-policy-holder-claims";
import {
   validateCommonPolicyHolderConvictions
} from "@validators/common/sub-components/validate-common-policy-holder-convictions";
import {isDateGreaterThenToday} from "@utils/date-time";



export const ValidateStep2Data = (data) => {

    const msgList = [];

    if(isNotStringOrEmptyString(data.policyStartDate)) {
       msgList.push({
            name: 'policyStartDate',
            message: 'Please specify the policy start date'
        });
    } else if(isDateLessThanNow(data.policyStartDate)) {
       msgList.push({
          name: 'policyStartDate',
          message: 'The policy start date cannot be in the past!'
       })
    }
    
    if(!isInLabelValueArrayAsString(data.bikeRider,BIKE_RIDER_OPTIONS)) {
       msgList.push({
          name: 'bikeRider',
          message: 'Please specify who will be riding the bike'
       })
    }
    
    if(!isInLabelValueArrayAsString(data.bikeUsage,BIKE_USAGE_OPTIONS)) {
       msgList.push({
          name: 'bikeUsage',
          message: 'Please specify the bike usage'
       })
    }
    
    if(!isInLabelValueArrayAsString(data.bikeLicenseType,BIKE_LICENSE_TYPE_OPTIONS)) {
       
       msgList.push({
          name: `bikeLicenseType`,
          message: `Please specify the bike license type`
       });
       
    }
    
    if(!isNotStringOrEmptyString(data.bikeLicenseType)) {
       
       if(!isValidDateTimeString(data.bikeLicenseDate)) {
          
          msgList.push({
             name: `bikeLicenseDate`,
             message: `Please specify the license obtaining date`
          });
          
       
       } else if(isDateGreaterThenToday(data.bikeLicenseDate)) {
          
          msgList.push({
             name : 'bikeLicenseDate',
             message : 'Bike license date cannot be in the future!'
          });
          
       }
       
    }
    
    if(!isInLabelValueArrayAsString(data.hasARidingQualification,YES_NO_CHOICE_OPTIONS)) {
       msgList.push({
          name: `hasARidingQualification`,
          message: `Please specify if you have a riding qualification`
       });
    }
    
    if(!isInLabelValueArrayAsString(data.isMemberOfBikeOrganisation,YES_NO_CHOICE_OPTIONS)) {
       msgList.push({
          name: `isMemberOfBikeOrganisation`,
          message: `Please specify if you are a member of a bike organisation`
       });
    }
    
    if(!isInLabelValueArrayAsString(data.bikeNoClaimBonusYears,BIKE_NO_CLAIM_BONUS_YEAR_OPTIONS)) {
       msgList.push({
          name: `bikeNoClaimBonusYears`,
          message: `Please specify the number of years you will receive a no claim bonus`
       });
    }
    
    if(!isInLabelValueArrayAsString(data.noOfOtherOwnedVehicles,OTHER_OWNED_VEHICLE_NUMBER_OPTIONS)) {
       msgList.push({
          name: `noOfOtherOwnedVehicles`,
          message: `Please specify the number of other vehicles you own`
       });
    }
    
    if(!isInLabelValueArrayAsString(data.noOfOtherOwnedAndInsuredVehicles,OTHER_OWNED_VEHICLE_NUMBER_OPTIONS)) {
       msgList.push({
          name: `noOfOtherOwnedAndInsuredVehicles`,
          message: `Please specify the number of other vehicles you own and are insured`
       });
    }
    
    if(!isInLabelValueArrayAsString(data.hasMedicalConditionsAffectingRiding,YES_NO_CHOICE_OPTIONS)) {
       msgList.push({
          name: `hasMedicalConditionsAffectingRiding`,
          message: `Please specify if you have medical conditions affecting your riding`
       });
    }
    
    validateCommonPolicyHolderClaims({
       data,
       msgList
    })
   
   validateCommonPolicyHolderConvictions({
      data,
      msgList
   })

    return msgList;

}